module.exports = __webpack_public_path__ + "static/media/brl_note_5.52036ef5.jpg";